import { Link } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";


export const labelConfig = {
  securityInstrument: "Security  Instrument Master",
  viewSecurityInstrument: "Security Instrument Details",
  addSecurityInstrument: "New Security Instrument",
  updateSecurityInstrument: "Update Security  Instrument",
  productSecurityInstrument: "Security  Instrument Listing",
  createSecurityInstrument: "Create Security  Instrument...",
  editSecurityInstrument: "Update Security  Instrument...",
  newSecurityInstrumentMsg: "Security Instrument was successfully created",
};

export const apiConfig={
  GetSecurityInstrument: BOM.baseUrl("securitymaster", "treasury"),
  Holidays: BOM.baseUrl("holidays"),
}

export const staticConfig={
    newSecurityInstrument: [
        { title: <Link to="/security-instrument">{labelConfig.securityInstrument}</Link> },
        {
          title: labelConfig.addSecurityInstrument,
        },
      ],
      viewSecurityInstrument: [
        { title: <Link to="/security-instrument">{labelConfig.securityInstrument}</Link> },
        {
          title: labelConfig.viewSecurityInstrument,
        },
      ],
      editSecurityInstrument: [
        { title: <Link to="/security-instrument">{labelConfig.securityInstrument}</Link> },
        {
          title: labelConfig.updateSecurityInstrument,
        },
      ],
      manageSecurityInstrument: [
        { title: labelConfig.securityInstrument },
      ],
}